export default __webpack_public_path__ + "static/media/retweet.3aac1e24.svg";